enum SpecialPricingEnum {
  SpecialNettPrice,
  PromoProductPrice,
  SaleRefused,
  List,
  ListWithDiscount,
}

export default SpecialPricingEnum;
